import React, { useEffect } from 'react';
import { RouteComponentProps } from 'react-router-dom';
import { useGlobalControls } from '../context/GlobalControlsContext';
import { useQueryStrings } from '../context/QueryStringContext';
import LineupDetailsPage from './LineupDetailsPage';
import OfferDetailsPage from './OfferDetailsPage';
import ExploreDetailsPage from './ExploreDetailsPage';

type DetailsDeciderProps = DetailsDeciderPropsBase & RouteComponentProps;

interface DetailsDeciderPropsBase {}

function DetailsDecider(props: DetailsDeciderProps) {
  const { ...rest } = props;
  const { qs } = useQueryStrings();
  const { toggleOverflow } = useGlobalControls();

  useEffect(() => {
    toggleOverflow('details', !!qs.event || !!qs.venue || !!qs.offer);
    document.querySelector('.blur-container')?.scrollTo({ top: 0 });
  }, [qs]);

  if (qs.event) {
    return <LineupDetailsPage {...rest} eventId={qs.event} />;
  }

  if (qs.venue) {
    return <ExploreDetailsPage {...rest} venueId={qs.venue} />;
  }

  if (qs.offer) {
    return <OfferDetailsPage {...rest} offerId={qs.offer} />;
  }

  return <></>;
}

export default DetailsDecider;
